import React from 'react';
import styled from '@xstyled/emotion';

const Container = styled.div`
  height: 4.5rem;
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  text-align: center;
  color: white;
  font-family: system;
`;

const Ticker = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #79d100;
  white-space: nowrap;
  font-size: 18px;
  padding: 0 4px;
`;

const Listed = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #026763;
  height: 16px;
  font-size: 10px;
  padding: 0 1;
`;

const Market = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #008273;
  height: 20px;
  font-size: 10px;
  padding: 0 1;
`;

const markets: Record<string, string> = {
  OSE: 'Oslo Børs',
  MERK: 'Euronext Growth',
  OAX: 'Euronext Expand',
  SSE: 'Nasdaq Stockholm',
  FNSE: 'First North Stockholm',
  XSAT: 'Aktietorget',
  NGM: 'NGM',
  'XNGM-NEST': 'NGM Equity',
  'XNGM-NDXS': 'NDX',
  NMTF: 'NGM Nordic MTF',
};

const getIsENX = (sector: keyof typeof markets = '') =>
  ['OSE', 'MERK', 'OAX'].includes(sector);

function MarketBadge({ ticker, market, sector }: MarketBadgeProps) {
  const isENX = getIsENX(sector);
  const m = sector ? markets[sector] : market;
  return (
    <Container>
      {isENX && (
        <>
          <Ticker>
            <span>{ticker}</span>
          </Ticker>
          <Listed>
            <span>Listed</span>
          </Listed>
          <Market>
            <span>{m}</span>
          </Market>
        </>
      )}
    </Container>
  );
}

interface MarketBadgeProps {
  ticker: string;
  /** E.g. Oslo Børs, Euronext Growth */
  market?: string;
  sector?: string;
}

export { MarketBadge };
